import { Product } from '~/Api/User/ProductGroup/CaLabeling/Product';
import { Reference } from '~/Api/User/ProductGroup/CaLabeling/Reference';

export class CaLabeling {
	public links: { [key: string]: string };

	public products: Product[];

	public reference: Reference;

	public constructor(links: { [key: string]: string }, products: Product[], reference: Reference) {
		this.links = links;
		this.products = products;
		this.reference = reference;
	}
}
